import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#262626",
        color: theme.palette.common.white
    },
    body: {
        fontSize: 14,
        fontFamily: 'SourceSansPro-Regular'
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        fontFamily: 'SourceSansPro-Regular',
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        }
    },
}))(TableRow);

const useStyles = makeStyles({
    tableContainer: {
        marginBottom: 40
    },
    table: {
        minWidth: 650,
        fontFamily: 'SourceSansPro-Regular',
    },
    link: {
        fontFamily: 'SourceSansPro-Regular',
        color: '#1f96a2',
        cursor: 'pointer'
    },
    collapsedRow: {
        cursor: 'pointer'
    }
});
// This component renders a table of release versions with expandable rows for sub-releases.
export const ReleaseTable = ({ data, expandedRows, handleRowClick, isExpanded }) => {
    const classes = useStyles();

    const renderRow = (row, isMainRelease) => {
        const versionTitle = `Version: ${row.internalVersion}, Platform: ${row.platformVersion}`;
        const hasSubReleases = row.subReleases && row.subReleases.length > 0;

        return (
            <React.Fragment key={row.version}>
                <StyledTableRow>
                    <StyledTableCell>
                        {/* // Show expand icon only for main releases with sub-releases */}
                        {isMainRelease && hasSubReleases ? (
                            <IconButton aria-label="expand row" size="small" onClick={() => handleRowClick(row.version)}>
                                {isExpanded(row.version) ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                            </IconButton>
                        ) : <div style={{ width: '40px' }} />}
                    </StyledTableCell>
                    <StyledTableCell>
                        {/* // Display version name with bold for main releases and italic for sub-releases */}
                        {isMainRelease ? <b title={versionTitle}>{row.version}</b> : <i className="tabSpace" title={versionTitle}>{row.version}</i>}
                    </StyledTableCell>
                    <StyledTableCell align="right">{row.supportType}</StyledTableCell>
                    <StyledTableCell align="right">{row.releaseDate}</StyledTableCell>
                    <StyledTableCell align="right">{isMainRelease ? <b>{row.endOfLife}</b> : row.endOfLife}</StyledTableCell>
                    <StyledTableCell align="left">{row.state}</StyledTableCell>
                    <StyledTableCell align="center">{row.link && <a target='_new' className={classes.link} href={row.link}>{row.releaseNotes}</a>}</StyledTableCell>
                </StyledTableRow>
                {isMainRelease && hasSubReleases && isExpanded(row.version) && row.subReleases.map(sub => renderRow(sub, false))}
            </React.Fragment>
        );
    };

    return (
        <div className={classes.tableContainer}>
            <TableContainer component={Paper}>
                <Table aria-label="a dense table" size="small" className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <StyledTableCell />
                            <StyledTableCell><b>Version Name</b></StyledTableCell>
                            <StyledTableCell align="right"><b>Support Type</b></StyledTableCell>
                            <StyledTableCell align="right"><b>Release Date</b></StyledTableCell>
                            <StyledTableCell align="right"><b>End Of Life</b></StyledTableCell>
                            <StyledTableCell align="left"><b>Active</b></StyledTableCell>
                            <StyledTableCell align="center"><b>Release Notes</b></StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data && data.map(row => {
                            const hasSubReleases = row.subReleases && row.subReleases.length > 0;
                            if (hasSubReleases && !isExpanded(row.version)) {
                                const versionTitle = `Version: ${row.internalVersion}, Platform: ${row.platformVersion}`;
                                return (
                                    <StyledTableRow key={row.version} onClick={() => handleRowClick(row.version)} className={classes.collapsedRow}>
                                        <StyledTableCell>
                                            <IconButton aria-label="expand row" size="small">
                                                <KeyboardArrowDownIcon />
                                            </IconButton>
                                        </StyledTableCell>
                                        <StyledTableCell colSpan={6}><b title={versionTitle}>{row.version}</b> ({row.state})</StyledTableCell>
                                    </StyledTableRow>
                                );
                            }
                            return renderRow(row, true);
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
};
